<template>
  <div>
    <div class="mb-1">
      <h4 class="mb-0">
        Сотрудники
      </h4>
      <div class="text-muted small">
        Все, у кого есть хотя бы одна роль. Чтобы дать роль новому человеку, найдите его ниже. Выдать можно только роль,
        все права которой есть у вас самих.
      </div>
    </div>

    <b-card class="mb-1">
      <v-select
        v-model="picked"
        label="email"
        :filterable="false"
        :options="userOptions"
        placeholder="Найти пользователя: e-mail, имя, фамилия или номер"
        @search="searchUsers"
      >
        <template #option="option">
          #{{ option.id }} {{ userName(option) }} ({{ option.email }})
        </template>
        <template #selected-option="option">
          {{ userName(option) }} ({{ option.email }})
        </template>
        <template #no-options>
          Введите хотя бы два символа
        </template>
      </v-select>
    </b-card>

    <user-roles-card
      v-if="selectedId"
      :key="selectedId"
      :user-id="selectedId"
      show-name
      @changed="load"
    />

    <b-card no-body>
      <b-table
        :items="staff"
        :fields="fields"
        :busy="loading"
        hover
        responsive
        show-empty
        empty-text="Ни у кого нет ролей"
        class="mb-0"
        @row-clicked="select"
      >
        <template #table-busy>
          <div class="text-center py-1">
            <b-spinner small />
          </div>
        </template>
        <template #cell(name)="{ item }">
          {{ userName(item) }}
          <div class="small text-muted">
            #{{ item.id }} · {{ item.email }}
          </div>
        </template>
        <template #cell(roles)="{ item }">
          <b-badge
            v-for="role in item.roles"
            :key="role.id"
            :variant="role.limited ? 'light-info' : 'light-primary'"
            class="mr-50 mb-25"
          >
            {{ role.name }}<template v-if="role.limited">
              · по стартам
            </template>
          </b-badge>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import {
  BBadge, BCard, BSpinner, BTable,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import aclApi from '@/services/acl-api.service'
import UserRolesCard from './UserRolesCard.vue'
import { userName } from './catalog'

export default {
  name: 'AclStaffPage',
  components: {
    BBadge, BCard, BSpinner, BTable, UserRolesCard, vSelect,
  },
  data() {
    return {
      staff: [],
      loading: false,
      picked: null,
      userOptions: [],
      fields: [
        { key: 'name', label: 'Сотрудник' },
        { key: 'roles', label: 'Роли' },
      ],
    }
  },
  computed: {
    selectedId() {
      return this.picked ? this.picked.id : null
    },
  },
  created() {
    this.load()
  },
  methods: {
    userName,
    async load() {
      this.loading = true
      try {
        this.staff = (await aclApi.staff()).data
      } finally {
        this.loading = false
      }
    },
    select(row) {
      this.picked = row
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    async searchUsers(q, loading) {
      if (!q || q.trim().length < 2) return
      loading(true)
      try {
        this.userOptions = (await aclApi.searchUsers(q)).data
      } finally {
        loading(false)
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
